import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { http } from '@/apis/aipass'
import { env } from '@/libs/env'

export const fetchPaymentSetting = createAsyncThunk('hotel/fetchPaymentSetting', async (hotelId: string, { rejectWithValue }) => {
  try {
    const response = await http({
      method: 'get',
      url: `${env('BASE_API_V3')}/payment-setting-by-hotel`,
      params: { hotelId: hotelId },
    })
    return response.data
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const computedPaymentMethodByOperation = (paymentSetting: PaymentTime[], operation: string): string[] => {
  const paymentSettingByOperation = paymentSetting.find(item => item.value === operation)
  if (!paymentSettingByOperation || !paymentSettingByOperation.is_enabled) {
    return []
  }

  const paymentMethodValues: string[] = []
  for (let index = 0; index < paymentSettingByOperation.payment_method.length; index++) {
    const paymentMethod = paymentSettingByOperation.payment_method[index]
    if (!paymentMethod.is_enabled) {
      continue
    }
    if (paymentMethod.value === 'DIRECT') {
      paymentMethodValues.push('cash')
    } else if (paymentMethod.value === 'CREDIT_CARD') {
      paymentMethodValues.push('creditCard')
    }
  }
  return paymentMethodValues
}

interface PaymentTime {
  id: string
  is_enabled: number
  payment_method: { id: string; is_enabled: number; value: string }[]
  value: string
}

export interface PaymentSetting {
  settings: {
    payment_time: PaymentTime[]
  }
}
export const paymentSettingSlice = createSlice({
  name: 'paymentSetting',
  initialState: {
    settings: {
      payment_time: [] as PaymentTime[],
    },
    loading: false,
    isFetched: false,
  },
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchPaymentSetting.pending, state => {
      state.loading = true
      state.isFetched = false
    })
    builder.addCase(fetchPaymentSetting.fulfilled, (state, action: PayloadAction<PaymentSetting>) => {
      state.settings = action.payload.settings
      state.isFetched = true
      state.loading = false
    })
    builder.addCase(fetchPaymentSetting.rejected, state => {
      state.loading = false
    })
  },
})

export const paymentSettingReducer = paymentSettingSlice.reducer
